async function fetchDiveStats(token) {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const diveCountResponse = await fetch(
      "/api/stats/countdives",
      { headers }
    );
    const diverCountResponse = await fetch(
      "/api/stats/countdivers",
      { headers }
    );
    const siteCountResponse = await fetch(
      "/api/stats/countdivesites",
      { headers }
    );

    if (
      !diveCountResponse.ok ||
      !diverCountResponse.ok ||
      !siteCountResponse.ok
    ) {
      throw new Error("Failed to fetch data from one or more APIs");
    }

    const diveCount = await diveCountResponse.json();
    const diverCount = await diverCountResponse.json();
    const siteCount = await siteCountResponse.json();

    return {
      diveCount: diveCount.count,
      diverCount: diverCount.count,
      siteCount: siteCount.count,
    };
  } catch (error) {
    console.error("Error fetching dive stats:", error);
    return {
      diveCount: null,
      diverCount: null,
      siteCount: null,
      error: error.message,
    };
  }
}

export default fetchDiveStats;
